import React, { useEffect, useState } from "react"
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import "../styles/styles.css";
import "../styles/styles.scss";
import "../styles/mobile.css";
import 'react-calendar/dist/Calendar.css';
import MatchStaffAssignments from '../layouts/MatchStaffAssignments';
import Admin from '../layouts/Admin';
import Main from '../layouts/Main';
import ManageMatchResult from '../layouts/ManageMatchResult';
import ManageApplication from '../layouts/ManageApplication';
import { AuthContext } from "../utilities/auth";
import { LanguageProvider } from "../utilities/i18n";
import { ChampionshipProvider } from "../utilities/championships";
import PrivateRoute from '../components/PrivateRoute';
import TeamRosters from '../layouts/TeamRosters';
import BlackList from '../layouts/BlackList'
import ManageBlackListPlayer from '../layouts/ManageBlackListPlayer';
import ApplicationsManagment from '../layouts/ApplicationsManagment';
import LeaguesManagement from '../layouts/LeaguesManagement';
import TeamsManagement from '../layouts/TeamsManagement';
import ManageTeam from '../layouts/ManageTeam';
import ManageCoach from '../layouts/ManageCoach';
import PlayersManagement from '../layouts/PlayersManagement';
import PlayerDuplicates from '../layouts/PlayerDuplicates';
import ManagePlayer from '../layouts/ManagePlayer';
import ManagePlayerApplication from '../layouts/ManagePlayerApplication';
import StagesManagement from '../layouts/StagesManagement';
import LeagueChampionsManagement from '../layouts/LeagueChampionsManagement';
import LeagueTourTeamManagement from '../layouts/LeagueTourTeamManagement';
import ManageMatchMedia from '../layouts/ManageMatchMedia';
import SelectMatchMedia from '../layouts/SelectMatchMedia';
import LeagueDisqualificationsManagement from '../layouts/LeagueDisqualificationsManagement';
import ManageAutoDisqualification from '../layouts/ManageAutoDisqualification';
import ManageDisqualification from '../layouts/ManageDisqualification';
import ScheduleManagement from '../layouts/ScheduleManagement';
import StadiumsManagement from '../layouts/StadiumsManagement';
import ManageStadium from '../layouts/ManageStadium';
import ManagePitch from '../layouts/ManagePitch';
import TournamentsManagement from '../layouts/TournamentsManagement';
import ManageCountry from '../layouts/ManageCountry';
import ManageLeague from '../layouts/ManageLeague';
import ManageLeagueRules from '../layouts/ManageLeagueRules';
import ManageSeason from '../layouts/ManageSeason';
import ManageCurator from '../layouts/ManageCurator';
import ManageTournamentStage from '../layouts/ManageTournamentStage';
import TournamentApplicationsManagement from '../layouts/TournamentApplicationsManagement';
import ManageTournamentApplication from '../layouts/ManageTournamentApplication';
import UsersManagement from '../layouts/UsersManagement';
import ManageUser from '../layouts/ManageUser';
import NewsManagement from '../layouts/NewsManagement';
import ManageNews from '../layouts/ManageNews';
import TimeSlots from '../layouts/TimeSlots';
import Reports from '../layouts/Reports';
import PlayerStats from '../layouts/PlayerStats';
import Infographics from '../layouts/Infographics';
import SponsorsManagement from '../layouts/SponsorsManagement';
import TabloPanel from '../layouts/TabloPanel';
import TabloOverlay from '../layouts/TabloOverlay';
import EditAccount from '../layouts/EditAccount';
import TransferWindowsManagement from '../layouts/TransferWindowsManagement';
import ManageTransferWindow from '../layouts/ManageTransferWindow';
import ManageSeasonTransferWindows from '../layouts/ManageSeasonTransferWindows';
import ClientForms from '../layouts/ClientForms';
import ManageClientForm from '../layouts/ManageClientForm';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
/* Keep last among app CSS so 16px form controls beat page styles on iOS. */
import "../styles/iosFormZoom.css";

/** After full-page mobile scroll lists, reset scroll so the next screen starts at the top. */
function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!window.matchMedia('(max-width: 900px)').matches) return;

    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    document.querySelectorAll('.adminMain, .pageWrapper, .st-layout, .st-scroll, .matchCenterWrapper').forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}

function App(props) {
  const existingTokens = JSON.parse(localStorage.getItem("userData"));
  const [userData, setUserData] = useState(existingTokens);

  const setData = React.useCallback((data) => {
    localStorage.setItem("userData", JSON.stringify(data ? data : false));
    setUserData(data);
  }, []);

  const authValue = React.useMemo(
    () => ({ userData, setUserData: setData }),
    [userData, setData]
  );

  return (
    <AuthContext.Provider value={authValue}>
      <LanguageProvider>
      <ChampionshipProvider>
      <Router>
        <ScrollToTopOnNavigate />
        <Switch>
          <Route exact path="/" component={Main} />
          <Route exact path="/tablo/overlay/:overlayKey" component={TabloOverlay} />
          <PrivateRoute path="/admin" component={Admin} />
          <PrivateRoute path="/tablo" exact component={TabloPanel} />
          <PrivateRoute path="/match_staff" component={MatchStaffAssignments} />
          <PrivateRoute path="/applications_managment" component={ApplicationsManagment} />
          <PrivateRoute path="/client_forms/:formId" component={ManageClientForm} />
          <PrivateRoute path="/client_forms" exact component={ClientForms} />
          <PrivateRoute path="/black_list/new" exact component={ManageBlackListPlayer} />
          <PrivateRoute path="/black_list/:playerId" component={ManageBlackListPlayer} />
          <PrivateRoute path="/black_list" exact component={BlackList} />
          {/* <PrivateRoute path="/leagues_management" component={LeaguesManagement} /> */}
          <PrivateRoute path="/stages_management" component={StagesManagement} />
          <PrivateRoute path="/league_champions" component={LeagueChampionsManagement} />
          <PrivateRoute path="/league_tour_team" component={LeagueTourTeamManagement} />
          <PrivateRoute path="/league_disqualifications/auto/new" exact component={ManageAutoDisqualification} />
          <PrivateRoute path="/league_disqualifications/auto/:leagueId" component={ManageAutoDisqualification} />
          <PrivateRoute path="/league_disqualifications/current/:playerId/:leagueId" component={ManageDisqualification} />
          <PrivateRoute path="/league_disqualifications/new" exact component={ManageDisqualification} />
          <PrivateRoute path="/league_disqualifications/:disqualificationId" component={ManageDisqualification} />
          <PrivateRoute path="/league_disqualifications" exact component={LeagueDisqualificationsManagement} />
          <PrivateRoute path="/teams_management/new" exact component={ManageTeam} />
          <PrivateRoute path="/teams_management/:teamId/player/new" exact component={ManagePlayer} />
          <PrivateRoute path="/teams_management/:teamId/player/:playerId/application/new" exact component={ManagePlayerApplication} />
          <PrivateRoute path="/teams_management/:teamId/player/:playerId/application/:appTeamId/:applicationId" component={ManagePlayerApplication} />
          <PrivateRoute path="/teams_management/:teamId/player/:playerId" component={ManagePlayer} />
          <PrivateRoute path="/teams_management/:teamId/coach/new" exact component={ManageCoach} />
          <PrivateRoute path="/teams_management/:teamId/coach/:coachId" component={ManageCoach} />
          <PrivateRoute path="/teams_management/:teamId" component={ManageTeam} />
          <PrivateRoute path="/teams_management" exact component={TeamsManagement} />
          <PrivateRoute path="/players_management/new" exact component={ManagePlayer} />
          <PrivateRoute path="/players_management/:playerId/application/new" exact component={ManagePlayerApplication} />
          <PrivateRoute path="/players_management/:playerId/application/:appTeamId/:applicationId" component={ManagePlayerApplication} />
          <PrivateRoute path="/players_management/:playerId" component={ManagePlayer} />
          <PrivateRoute path="/players_management" exact component={PlayersManagement} />
          <PrivateRoute path="/player_duplicates" exact component={PlayerDuplicates} />
          <PrivateRoute path="/player/:playerId" component={ManagePlayer} />
          <PrivateRoute path="/schedule_management" component={ScheduleManagement} />
          <PrivateRoute path="/stadiums_management/new" exact component={ManageStadium} />
          <PrivateRoute path="/stadiums_management/:stadiumId/pitch/new" exact component={ManagePitch} />
          <PrivateRoute path="/stadiums_management/:stadiumId/pitch/:pitchId" component={ManagePitch} />
          <PrivateRoute path="/stadiums_management/:stadiumId" component={ManageStadium} />
          <PrivateRoute path="/stadiums_management" exact component={StadiumsManagement} />
          <PrivateRoute path="/tournaments/applications/new" exact component={ManageTournamentApplication} />
          <PrivateRoute path="/tournaments/applications/:applicationId" component={ManageTournamentApplication} />
          <PrivateRoute path="/tournaments/applications" exact component={TournamentApplicationsManagement} />
          <PrivateRoute path="/tournaments/new" exact component={ManageCountry} />
          <PrivateRoute path="/tournaments/:countryId/league/new" exact component={ManageLeague} />
          <PrivateRoute path="/tournaments/:countryId/league/:leagueId/season/new" exact component={ManageSeason} />
          <PrivateRoute path="/tournaments/:countryId/league/:leagueId/season/:seasonId/stage/new" exact component={ManageTournamentStage} />
          <PrivateRoute path="/tournaments/:countryId/league/:leagueId/season/:seasonId/stage/:stageId" component={ManageTournamentStage} />
          <PrivateRoute path="/tournaments/:countryId/league/:leagueId/season/:seasonId" component={ManageSeason} />
          <PrivateRoute path="/tournaments/:countryId/league/:leagueId/curator/new" exact component={ManageCurator} />
          <PrivateRoute path="/tournaments/:countryId/league/:leagueId/curator/:curatorId" component={ManageCurator} />
          <PrivateRoute path="/tournaments/:countryId/league/:leagueId/rules" exact component={ManageLeagueRules} />
          <PrivateRoute path="/tournaments/:countryId/league/:leagueId" component={ManageLeague} />
          <PrivateRoute path="/tournaments/:countryId" component={ManageCountry} />
          <PrivateRoute path="/tournaments" exact component={TournamentsManagement} />
          <PrivateRoute path="/transfer_windows/new" exact component={ManageTransferWindow} />
          <PrivateRoute path="/transfer_windows/seasons/:leagueId" component={ManageSeasonTransferWindows} />
          <PrivateRoute path="/transfer_windows/:leagueId" component={ManageTransferWindow} />
          <PrivateRoute path="/transfer_windows" exact component={TransferWindowsManagement} />
          <PrivateRoute path="/account" component={EditAccount} />
          <PrivateRoute path="/users/new" exact component={ManageUser} />
          <PrivateRoute path="/users/:userId" component={ManageUser} />
          <PrivateRoute path="/users" exact component={UsersManagement} />
          <PrivateRoute path="/news/new" exact component={ManageNews} />
          <PrivateRoute path="/news/:newsId" component={ManageNews} />
          <PrivateRoute path="/news" exact component={NewsManagement} />
          <PrivateRoute path="/time_slots" exact component={TimeSlots} />
          <PrivateRoute path="/reports" exact component={Reports} />
          <PrivateRoute path="/player_stats" exact component={PlayerStats} />
          <PrivateRoute path="/infographics/sponsors" exact component={SponsorsManagement} />
          <PrivateRoute path="/infographics" exact component={Infographics} />
          <PrivateRoute path="/manage_match/:id" component={ManageMatchResult} />
          <PrivateRoute path="/select_match_media" component={SelectMatchMedia} />
          <PrivateRoute path="/manage_match_media/:matchId" component={ManageMatchMedia} />
          <PrivateRoute path="/manage_application/:id" component={ManageApplication} />
          <PrivateRoute path="/team_rosters/:id/:application_id" component={TeamRosters} />
          </Switch>
      </Router>
      </ChampionshipProvider>
      </LanguageProvider>
    </AuthContext.Provider>
  );
}

export default App;